import { LoginScreen } from "./screen/login"
import { MaintenanceScreen } from "./screen/maintenance"
import { Route, Switch, Redirect } from 'react-router-dom';
import { NotFoundScreen } from "./screen/404";
import { PayScreen } from "./screen/pay";
import { HomeScreen } from "./screen/home";
import { TermScreen } from "./screen/term";
import { PrivacyScreen } from "./screen/privacy";
import { SecureScreen } from "./screen/secure";
import { GameHomeScreen } from "./screen/game"
import { GuideScreen } from "./screen/guide"

export const CheckLogin = () => {

    if (process.env.REACT_APP_MAINTENANCE == 1) {
        return <MaintenanceScreen />
    }


    return (
        <Switch>
            <Route exact path="/" component={HomeScreen} />
            <Route exact path="/dash"
                render={({ match }) => (<SecureScreen {...match} component={<GameHomeScreen />} />)}

            />
            <Route exact path="/pay/gcash/:price"
                render={({ match }) => (<SecureScreen {...match} component={<PayScreen />} />)}

            />
            <Route exact path="/term" render={(props) => (<TermScreen />)} />
            <Route exact path="/privacy" render={(props) => (<PrivacyScreen />)} />
            <Route exact path="/guide" render={(props) => (<GuideScreen />)} />
            <Route path="*" component={NotFoundScreen} />
        </Switch>
    )
}